import { jsx as _jsx } from "react/jsx-runtime";
import { EmbeddingContext } from "@geome/react-next/lib/context/embedding";
import { useCallback, useContext, useRef } from "react";
import { getShadowRoot } from "./getShadowRoot";
export const HashLink = ({ elementId, children, className }) => {
    const embedding = useContext(EmbeddingContext);
    switch (embedding) {
        case "CustomElement": {
            return (_jsx(HashLinkEmbedded, { className: className, elementId: elementId, children: children }));
        }
        case null:
        case "iframe": {
            return (_jsx("a", { className: className, href: `#${elementId}`, children: children }));
        }
    }
};
const HashLinkEmbedded = ({ elementId, children, className }) => {
    const buttonRef = useRef(null);
    const handleClick = useCallback(() => {
        if (!buttonRef.current)
            return;
        const root = getShadowRoot(buttonRef.current);
        const element = root.getElementById(elementId);
        if (!element) {
            throw new Error(`no element corresponding to elementId "${elementId}"`);
        }
        element.scrollIntoView(true);
    }, [elementId]);
    return (_jsx("button", { className: className, onClick: handleClick, ref: buttonRef, children: children }));
};
